import React from 'react'
import './subject.css'

class ManageSubject extends React.Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <div className="manage-subject">
                <img className="manage-subject-img manage-subject-img1" src={require("../assert/box_white.png")}></img>
                <img className="manage-subject-img manage-subject-img2" src={require("../assert/sub_white.png")}></img>
                <img className="manage-subject-img manage-subject-img3" src={require("../assert/add_white.png")}></img>
                <select className="manage-subject-img question-choice-subject">
                    <option value="单选题">单选题</option>
                    <option value="多选题">多选题</option>
                    <option value="文本题">文本题</option>
                </select>
                <img className="manage-subject-img manage-subject-img4" src={require("../assert/picture_white.png")}></img>
                <img className="manage-subject-img manage-subject-img5" src={require("../assert/form_white.png")}></img>
                <img className="manage-subject-img manage-subject-img6" src={require("../assert/preview_white.png")}></img>
                <img className="manage-subject-img manage-subject-img7" src={require("../assert/set_white.png")}></img>

            </div>
        );
    }
}

export default ManageSubject;